<script setup lang="ts">
import KTime from '@/components/times/KTime.vue';
import * as commonConstants from '@/constants/common';

export interface Props {
  name?: string;
  datetime?: string;
}

const props = withDefaults(defineProps<Props>(), {
  name: commonConstants.EM_DASH,
  datetime: undefined,
});
</script>

<template>
  <section
    :class="$style.smsChatRecipientSection"
    data-testid="smsChatRecipientSection"
  >
    <h2 :class="$style.h2">{{ props.name }}</h2>
    <KTime :datetime="props.datetime" :class="$style.time" />
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.smsChatRecipientSection {
  text-align: center;
}
  .h2 {
    color: colors.$color-text-secondary;
    font-size: 18px;
    margin-top: 0;
  }
  .time {
    color: colors.$color-text-tertiary;
    font-size: 14px;
  }
</style>
